import { render } from "./InstructionalCard.vue?vue&type=template&id=a4088f6c"
import script from "./InstructionalCard.vue?vue&type=script&lang=js"
export * from "./InstructionalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__